var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import get from "lodash.get";
import { theme as defaultTheme } from "./styled-theme";
export function bonfireGet() {
    var path = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        path[_i] = arguments[_i];
    }
    return makeThemeGetter(function (_a) {
        var theme = _a.theme;
        // styled-components provides an empty object when no theme is available.
        if (theme.bonfire === undefined) {
            theme = defaultTheme;
        }
        return get(theme, __spreadArray(["bonfire"], __read(path), false));
    });
}
function transform(transformer) {
    var _this = this;
    return makeThemeGetter(function (props) {
        var value = _this(props);
        return transformer(value);
    });
}
function half() {
    var _this = this;
    return makeThemeGetter(function (props) {
        var value = _this(props);
        return Math.floor(Number(value) / 2);
    });
}
function defaultValue(theme) {
    return this({ theme: theme || defaultTheme });
}
function makeThemeGetter(coreFunc) {
    return Object.assign(coreFunc, {
        transform: transform,
        half: half,
        defaultValue: defaultValue
    });
}
//# sourceMappingURL=utils.js.map